var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-1"},[_c('ckeditor',{attrs:{"value":_vm.content,"config":_vm.editorConfig,"editor":_vm.editor},on:{"input":_vm.emitInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }